import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeLenguage } from "../../redux/actions";
import es from "../../imgs/spain.png"
import en from "../../imgs/united-states.png"

const NavBar = () => {
  const location = useLocation();
  const history = useNavigate();
  const dispatch = useDispatch(); //eslint-disable-line
  const { lenguage } = useSelector((s) => s); //eslint-disable-line

  return (
    <>
      <header className="navbar_container">
        <button onClick={() => history(-1)} className="btn-goBack">
          {lenguage ? "Go back" : "Volver"}
        </button>
        {location.pathname !== "/home" && (
          <div className="btn-goHome">
            <NavLink to="/home">
              <button> {lenguage ? "Home" : "Inicio"}</button>
            </NavLink>
          </div>
        )}
        {location.pathname !== "/about" && (
          <div className="btn-about">
            <NavLink to="/about">
              <button>About</button>
            </NavLink>
          </div>
        )}
        {location.pathname !== "/createrace" && (
          <div className="btn-createrace">
            <NavLink to="/createrace">
              <button>{lenguage ? "Create a breed" : "Crea una raza"}</button>
            </NavLink>
          </div>
        )}
        <button onClick={() => dispatch(changeLenguage())} className="btn-lenguage">
        {lenguage ? (<img src={es} alt="es" />):  (<img src={en} alt="en" />)}
        </button>
      </header>
    </>
  );
};

export default NavBar;
